<template>
  <div>
    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuIndex: '',
      menu: [
        {
          name: "柴油",
          path: '/oilStation/fuelSales/onecar/table',
        },
      ],
    };
  },
  methods: {},
  mounted() {
    this.menuIndex = this.$route.path
  },
};
</script>
